export default {
  settings: {
    changeSettingsPasscode: 'Change settings passcode',
    chooseDefaultSurvey: 'Choose default survey',
    congratulations: 'Congratulations!',
    downloadSurveys: 'Download latest survey settings',
    heading: 'Settings',
    lastSynchronised: 'Device last synchronised: {n}',
    // not in use
    lastUploaded: 'Device last uploaded surveys: {n}',
    // not in use
    manageTeam: 'Manage team',
    never: 'Never',
    resetConfirmation: 'Are you sure you want to reset this device?',
    resetDevice: 'Reset device',
    resetError: 'We could not deregister your device. This will need to be done manually through back office.',
    resetSuccess: 'We have successfully reset your device.',
    resetWait: 'Please wait while we are resetting your device',
    surveysDownloaded: 'The latest survey settings have been successfully downloaded.',
    surveysDownloadError: 'We could not download the survey settings.',
    surveysDownloading: 'Please wait while we download the latest survey settings',
    surveysUploaded: 'We could not upload any completed surveys | {surveys} completed survey has been successfully uploaded. | {surveys} completed surveys have been successfully uploaded.',
    surveysUploadError: 'We could not upload the remaining completed survey | We could not upload the remaining {surveys} completed surveys.',
    surveysUploadErrorTitle: 'Error Uploading Surveys',
    surveysUploading: 'Please wait while we upload completed surveys...',
    surveyUploadedCount: 'Uploaded: {n}',
    uploadSurveys: 'No surveys to upload | Upload completed survey ({n}) | Upload completed surveys ({n})',
    updateApp: 'Update App',
    appUpdating: 'Please wait whilst we install the latest updates...',
    appUpdated: 'App Updated',
    updateAvailable: 'A new version of the app is available. Please download the latest version.',
    menuInsights: {
      download: 'Download products',
      downloading: 'Please wait while we download your products',
      complete: 'Congratulations! The latest products have been successfully downloaded',
      error: 'We could not download the latest products'
    },
    isStandAlone: 'Is standalone: ',
    isAPK: 'Is APK: ',
    pwaStatuses: 'PWA Statuses',
    pwaMode: 'Is running as: ',
    pwaModes: {
      apk: 'Installed APK',
      pwa: 'Installed PWA',
      web: 'Web Browser'
    },
    yes: 'Yes',
    no: 'No'
  }
};